import { useEffect, useState, useRef } from 'react'
import TextBoxControl from '../../Controls/TextBoxControl';
import ButtonControl from "../../Controls/ButtonControl"
import Button from 'react-bootstrap/Button';
import { useNavigate } from "react-router-dom";
import "../../assets/css/Login.css"
import {
    SetLocal,
    ClearLocal,
    FetchService,
    IsValidNationalCode,
    IsEmptyString,
    IsEmptyInput,
    Base64Type
} from "../../Base/BaseControl";
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import SelectControl from '../../Controls/SelectControl';


let FileExt = '';
export default function Index({ Click, page }) {
    const textBoxFileNumberRef = useRef(null);
    const textBoxLetterNumberRef = useRef(null);

    const [showModal, setShowModal] = useState(false);
    const [getPdf, setPdf] = useState('');
    const inputSelectRef = useRef(null);
    const [getSelectData, setSelectData] = useState([]);
    const [comboRegionDisabled, setComboRegionDisabled] = useState(true);
    const [isConnectionAttrributeCalled, setIsConnectionAttrributeCalled] = useState(false);

    const navigate = useNavigate();
    //const [nationalCode, checkNationalCode] = useState(true);

    useEffect(() => {
        var inputValue = {};
        FetchService("General/IsMultiRegion", inputValue, IsMultiRegionSuccess, IsMultiRegionFail);


    }, []);
    const IsMultiRegionSuccess = (ServiceResult) => {
        var inputValue = {};
        FetchService("General/Abstract/BasicInfo/ShowRegionAbstractList", inputValue, ShowRegionAbstractListSuccess);
    }
    const IsMultiRegionFail = (ServiceResult) => {
        setComboRegionDisabled(true)
    }

    const ShowRegionAbstractListSuccess = (ServiceResult) => {
        setSelectData(ServiceResult.RegionInfo);
        setComboRegionDisabled(false)

    }
    const GetConnetionAttribute = () => {
        let input = {
            regionCode: inputSelectRef.current?.value || 0,
        }
        FetchService("General/GetConnectionAttribute", input, GetConnetionAttributeSuccess)
    }
    const GetConnetionAttributeSuccess = (ServiceResult) => {
        if (ServiceResult) {
            setIsConnectionAttrributeCalled(true)
        }
    }


    const validateLetterSubmit = () => {
        if (IsEmptyInput(textBoxFileNumberRef))
            return false;

        if (IsEmptyInput(textBoxLetterNumberRef))
            return false;

        if (!comboRegionDisabled && (!isConnectionAttrributeCalled || !inputSelectRef.current?.value)) {
			toast.error('لطفا منطقه را انتخاب نمایید');
			return false
		}


        var inputValue = {
            FileNumber: Number(textBoxFileNumberRef.current.value),
            LetterNumber: Number(textBoxLetterNumberRef.current.value),
            regionID: Number(inputSelectRef.current?.value) || 0
        };
        FetchService("General/ValidateLetter", inputValue, validateLetterSubmitSuccess);
    }



    const validateLetterSubmitSuccess = (ServiceResult) => {
        setPdf("data:application/pdf;base64," + ServiceResult);
        setShowModal(true)


    }



    return (
        <div id="bglogin">
            <div className="main">
                <div className="formLogin">
                    <div>
                        <div className='my-3'>
                            <SelectControl
                                data={getSelectData}
                                inputRef={inputSelectRef}
                                title={"منطقه:"}
                                required={!comboRegionDisabled}
                                disabled={comboRegionDisabled}
                                onChange={() => GetConnetionAttribute()}
                            />
                        </div>

                        <TextBoxControl
                            inputRef={textBoxFileNumberRef}
                            title="شماره پرونده:"
                            onlyNumbers={true}
                            required={true}
                            placeholder="شماره پرونده خود را وارد نمایید"
                        />

                        <TextBoxControl
                            inputRef={textBoxLetterNumberRef}
                            title="شماره نامه:"
                            required={true}
                            placeholder="شماره نامه خود را وارد نمایید"
                        />



                        <ButtonControl
                            onClick={validateLetterSubmit}
                            variant="primary"
                            title="تایید"
                        />

                        <ButtonControl
                            onClick={() => navigate("/")}
                            variant="danger mx-2"
                            title="بازگشت"
                        />
                    </div>
                </div>
            </div>
            <Modal dialogClassName="modalUi" show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <iframe src={getPdf} width="100%" style={{ height: "500px" }}></iframe>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={() => setShowModal(false)}>
                        بستن
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}